import { render, staticRenderFns } from "./ApeDrawer.vue?vue&type=template&id=0f20831e&scoped=true"
import script from "./ApeDrawer.vue?vue&type=script&lang=js"
export * from "./ApeDrawer.vue?vue&type=script&lang=js"
import style0 from "./ApeDrawer.vue?vue&type=style&index=0&id=0f20831e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20831e",
  null
  
)

export default component.exports